<script>
    export let h = "h";
    export let b = "b";
    export let l = "l";
</script>

<div>
    <svg viewBox="0 0 350 320" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <marker
                id="seta2"
                viewBox="0 0 16 8"
                refX="0"
                refY="4"
                orient="auto"
                markerUnits="strokeWidth"
                markerWidth="16"
                markerHeight="8"
                style="fill:#000000"
            >
                <path d="M 16,0 L 16,8 L 0,4 L 16,0 z " id="path6997" />
            </marker>
            <marker
                id="seta1"
                viewBox="0 0 16 8"
                refX="16"
                refY="4"
                orient="auto"
                markerUnits="strokeWidth"
                markerWidth="16"
                markerHeight="8"
                style="fill:#000000"
            >
                <path d="M 0,0 L 0,8 L 16,4 L 0,0 z " id="path6994" />
            </marker>
        </defs>
        <g
            id="facesocultas"
            transform="matrix(1, 0, 0, 1, -54, -54)"
            style="fill:none;stroke:#c0c0c0;stroke-width:1;stroke-dasharray:12, 4"
        >
            <line x1="60" y1="260" x2="200" y2="225" id="line7000" />
            <line x1="340" y1="260" x2="200" y2="225" id="line7002" />
            <line x1="200" y1="320" x2="200" y2="60" id="line7004" />
        </g>
        <g
            id="faces"
            style="fill:none;stroke:#000000;stroke-width:3;stroke-linejoin:round"
        >
            <polygon
                points="200,320 340,260 340,80 200,110 200,320 "
                id="polygon7007"
                style="fill:#0000dd;fill-opacity:0.18518515"
                transform="translate(-54,-54)"
            />
            <polygon
                points="200,320 60,260 60,80 200,110 200,320 "
                id="polygon7009"
                style="fill:#0000d5;fill-opacity:0.18518515"
                transform="translate(-54,-54)"
            />
            <polygon
                points="200,110 60,80 200,60 340,80 200,110 "
                id="polygon7011"
                style="fill:#0000d5;fill-opacity:0.18518515"
                transform="translate(-54,-54)"
            />
        </g>
        <g
            id="cota1"
            transform="matrix(1, 0, 0, 1, -54, -54)"
            style="stroke:#000000"
        >
            <line x1="345" y1="80" x2="375" y2="80" id="line7014" />
            <line x1="345" y1="260" x2="375" y2="260" id="line7016" />
            <line
                x1="368"
                y1="80"
                x2="368"
                y2="260"
                id="line7018"
                style="marker-start:url(#seta2);marker-end:url(#seta1)"
            />
        </g>
        <g
            id="cota2"
            transform="matrix(1, 0, 0, 1, -54, -54)"
            style="stroke:#000000"
        >
            <line x1="340" y1="265" x2="340" y2="295" id="line7021" />
            <line x1="200" y1="325" x2="200" y2="355" id="line7023" />
            <line
                x1="200"
                y1="348"
                x2="340"
                y2="288"
                id="line7025"
                style="marker-start:url(#seta2);marker-end:url(#seta1)"
            />
        </g>
        <g
            id="cota3"
            transform="matrix(1, 0, 0, 1, -54, -54)"
            style="stroke:#000000"
        >
            <line x1="60" y1="265" x2="60" y2="295" id="line7028" />
            <line
                x1="200"
                y1="348"
                x2="60"
                y2="288"
                id="line7030"
                style="marker-start:url(#seta2);marker-end:url(#seta1)"
            />
        </g>
        <text
            x="321"
            y="124"
            style="font-size: 18.75px; font-family: Tahoma; white-space: pre;"
            id="text7032">{h}</text
        >
        <text
            x="221"
            y="288"
            style="font-size: 18.75px; font-family: Tahoma; white-space: pre;"
            id="text7034">{l}</text
        >
        <text
            x="61"
            y="288"
            style="font-size: 18.75px; font-family: Tahoma; white-space: pre;"
            id="text7036">{b}</text
        >
    </svg>
</div>

<style>
    svg {
        max-width: 50%;
        /* width: auto; */
        /* height: auto; */
    }
</style>
